import { Reveal } from "../Reveal";
import { Link } from "react-router-dom";
import { FileText, Linkedin, Compass, Sparkles, ArrowRight } from "lucide-react";

const services = [
  { icon: FileText, name: "Resume Writing", price: "₹399", desc: "ATS-optimized, achievement-driven resumes engineered for technical and executive roles.", tags: ["ATS-ready", "1–3 rounds"] },
  { icon: Linkedin, name: "LinkedIn Optimization", price: "₹199", desc: "A magnetic profile that recruiters find and remember — headline, About, and experience rewritten.", tags: ["SEO keywords", "Banner tips"] },
  { icon: Compass, name: "Career Consulting", price: "₹499", desc: "1:1 strategy on positioning, target roles, salary negotiation and interview preparation.", tags: ["60-min calls", "Action plan"] },
  { icon: Sparkles, name: "The Full Package", price: "₹599", desc: "Resume + LinkedIn + consulting + priority access to our curated job opportunities.", tags: ["Best value", "Priority leads"] },
];

export default function Services() {
  return (
    <section id="services" className="bg-navy text-white grain relative py-28 lg:py-36 overflow-hidden" data-testid="services-section">
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div>
            <span className="overline text-cobalt-light">What we do</span>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mt-4 leading-[1.02]">
              Services built to <span className="italic text-cobalt-light">get hired.</span>
            </h2>
          </div>
          <p className="text-white/60 max-w-sm text-lg">Transparent packages. Real writers. Measurable outcomes for professionals at every level.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.map((s, i) => (
            <Reveal key={s.name} delay={i * 0.08}>
              <div data-testid={`service-card-${i}`}
                className="h-full bg-white/[0.04] border border-white/10 p-7 hover:bg-white/[0.08] hover:border-cobalt-light/50 transition-colors">
                <s.icon size={28} className="text-cobalt-light" strokeWidth={1.6} />
                <h3 className="font-display text-2xl font-semibold mt-6">{s.name}</h3>
                <p className="text-white/55 mt-3 leading-relaxed text-sm">{s.desc}</p>
                <div className="flex flex-wrap gap-2 mt-5">
                  {s.tags.map((t) => (
                    <span key={t} className="font-mono-ui text-[0.6rem] uppercase tracking-widest border border-white/20 px-2.5 py-1 text-white/70">{t}</span>
                  ))}
                </div>
                <p className="font-display text-lg mt-6 text-cobalt-light">{s.price}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex justify-center">
            <Link to="/pricing" data-testid="services-pricing-cta"
              className="group inline-flex items-center gap-2 px-8 py-4 rounded-full bg-white text-navy font-medium hover:bg-cobalt hover:text-white transition-colors">
              View pricing & pay securely
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-0.5" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
